<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="hide">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="提现单号">
            <a-tooltip :title="detailData.withdrawalNo || '--'">
              <span class="text-ellipsis">{{ detailData.withdrawalNo || '--' }}</span>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item label="用户手机号">{{ detailData.phone || '--' }}</a-descriptions-item>
          <a-descriptions-item label="姓名">
            {{ (detailData.surname || '') + (detailData.name || '') || '--' }}
          </a-descriptions-item>
          <a-descriptions-item label="提现类型">
            <a-tag :color="getWithdrawalTypeColor(detailData.withdrawalType)">
              {{ getWithdrawalTypeText(detailData.withdrawalType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="提现账户">
            <a-tag :color="detailData.withdrawalAccount === 0 ? 'blue' : 'green'">
              {{ detailData.withdrawalAccount === 0 ? '余额' : '押金' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="审核状态">
            <a-tag :color="getWithdrawalStateColor(detailData.withdrawalState)">
              {{ getWithdrawalStateText(detailData.withdrawalState) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="提现角色">{{ detailData.withdrawalRole || '--' }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '--' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="金额信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="提现金额">
            <span style="color: #f5222d; font-size: 16px; font-weight: bold">¥{{ detailData.withdrawalMoney || 0 }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="手续费">¥{{ detailData.fee || 0 }}</a-descriptions-item>
          <a-descriptions-item label="提现前金额">¥{{ detailData.withdrawalFrontMoney || 0 }}</a-descriptions-item>
          <a-descriptions-item label="提现后金额">¥{{ detailData.withdrawalAfterMoney || 0 }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions
          title="收款账户信息"
          :column="2"
          bordered
          style="margin-top: 16px"
          v-if="detailData.withdrawalType !== undefined"
        >
          <a-descriptions-item label="账户类型">
            <a-tag>{{ detailData.type === 0 ? '公司' : '个人' }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="账户名/开户行" v-if="detailData.account">{{ detailData.account }}</a-descriptions-item>
          <a-descriptions-item label="银行名称" v-if="detailData.bankName">{{ detailData.bankName }}</a-descriptions-item>
          <a-descriptions-item label="银行账号" v-if="detailData.bankAccount">
            <a-tooltip :title="detailData.bankAccount">
              <span class="text-ellipsis">{{ detailData.bankAccount }}</span>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item label="银行代码" v-if="detailData.bankCode">{{ detailData.bankCode }}</a-descriptions-item>
          <a-descriptions-item label="企业名称" v-if="detailData.companyName">{{ detailData.companyName }}</a-descriptions-item>
          <a-descriptions-item label="邮箱" v-if="detailData.email">{{ detailData.email }}</a-descriptions-item>
          <a-descriptions-item label="地址" v-if="detailData.address">{{ detailData.address }}</a-descriptions-item>
          <a-descriptions-item label="预留手机号" v-if="detailData.userPhone">{{ detailData.userPhone }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="审核信息" :column="2" bordered style="margin-top: 16px" v-if="hasAuditInfo">
          <a-descriptions-item label="审核时间" v-if="detailData.withdrawalExamineTime">
            {{ formatTime(detailData.withdrawalExamineTime) }}
          </a-descriptions-item>
          <a-descriptions-item label="审核人员手机号" v-if="detailData.withdrawalExamineUserPhone">
            {{ detailData.withdrawalExamineUserPhone }}
          </a-descriptions-item>
          <a-descriptions-item label="审核人员ID" v-if="detailData.withdrawalExamineUserId">
            {{ detailData.withdrawalExamineUserId }}
          </a-descriptions-item>
          <a-descriptions-item label="审核人员IP" v-if="detailData.withdrawalExamineIp">
            {{ detailData.withdrawalExamineIp }}
          </a-descriptions-item>
          <a-descriptions-item label="提现到账时间" v-if="detailData.withdrawalArriveTime">
            {{ formatTime(detailData.withdrawalArriveTime) }}
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="其他信息" :column="2" bordered style="margin-top: 16px" v-if="hasOtherInfo">
          <a-descriptions-item label="用户ID" v-if="detailData.userId">{{ detailData.userId }}</a-descriptions-item>
          <a-descriptions-item label="客户IP地址" v-if="detailData.customIp">{{ detailData.customIp }}</a-descriptions-item>
          <a-descriptions-item label="客户MAC地址" v-if="detailData.customMac">{{ detailData.customMac }}</a-descriptions-item>
          <a-descriptions-item label="客户经度" v-if="detailData.customLng">{{ detailData.customLng }}</a-descriptions-item>
          <a-descriptions-item label="客户纬度" v-if="detailData.customLat">{{ detailData.customLat }}</a-descriptions-item>
          <a-descriptions-item label="客户手机基本信息" v-if="detailData.customBasic">{{ detailData.customBasic }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions
          title="备注信息"
          :column="1"
          bordered
          style="margin-top: 16px"
          v-if="detailData.withdrawalReason"
        >
          <a-descriptions-item label="审核失败原因">{{ detailData.withdrawalReason || '无备注' }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getWithdrawalDetail } from '@/api/pressure/fund'
import { message } from 'ant-design-vue'

export default {
  name: 'FundWithdrawalDetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
    }
  },
  computed: {
    title() {
      return '资金提现详情'
    },
    hasAuditInfo() {
      return (
        this.detailData.withdrawalExamineTime ||
        this.detailData.withdrawalExamineUserPhone ||
        this.detailData.withdrawalExamineUserId ||
        this.detailData.withdrawalExamineIp ||
        this.detailData.withdrawalArriveTime
      )
    },
    hasOtherInfo() {
      return (
        this.detailData.userId ||
        this.detailData.customIp ||
        this.detailData.customMac ||
        this.detailData.customLng ||
        this.detailData.customLat ||
        this.detailData.customBasic
      )
    },
  },
  methods: {
    init(record) {
      this.visible = true
      if (record && record.id) {
        this.loadDetail(record.id)
      } else {
        this.detailData = {}
      }
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getWithdrawalDetail(id)
        if (response && response.data) {
          this.detailData = response.data
        } else {
          message.error('获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(time) {
      if (!time) return '--'
      return time
    },
    getWithdrawalTypeText(type) {
      const map = {
        0: '支付宝',
        1: '微信',
        2: '银行卡',
      }
      return map[type] || '未知'
    },
    getWithdrawalTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
      }
      return map[type] || 'gray'
    },
    getWithdrawalStateText(state) {
      const map = {
        0: '审核中',
        1: '款项处理中',
        2: '提现成功',
        3: '提现失败',
        4: '打回',
      }
      return map[state] || '未知'
    },
    getWithdrawalStateColor(state) {
      const map = {
        0: 'orange',
        1: 'blue',
        2: 'green',
        3: 'red',
        4: 'purple',
      }
      return map[state] || 'gray'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.ant-descriptions-title) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

